<template>
	<div v-if="Object.keys(company).length > 0" class="block w-full h-full">
		<DjCardCompany
			:company="company"
			:langs="langs"
			:locale="locale"
			:loading="loading"
			:isSaved="Boolean(isAuth) && !updatingCompany && isSavedCompany()"
			@toggle-saved="toggleSavedCompany()"
			@on-click="navigateToCompanyProfile(company)"
		/>
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import type { CompanyDto } from "~/types/company";

export default defineComponent({
	name: "CardCompany",
	props: {
		company: {
			type: Object as () => CompanyDto,
			default: () => {
				return {} as CompanyDto;
			},
		},
		dataUrl: {
			type: String,
			default: "company", // Default API
		},
		loading: {
			type: Boolean,
			default: false,
		},
		newTab: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const router = useRouter();
		const isAuth = useState<boolean>("isAuth");
		const gtm = useGTM();

		const { locale } = useI18n();
		const langs = useLangs.job;
		const updatingCompany = ref(false);

		function navigateToCompanyProfile(company: CompanyDto) {
			const currentLocale = locale.value;
			const companySlug = company.slug;
			if (props.newTab) {
				window.open(`/${currentLocale}/company/${companySlug}`, "_blank");
			} else {
				router.push({
					path: `/${currentLocale}/company/${companySlug}`,
				});
			}
		}

		function toggleSavedCompany() {
			if (isAuth.value) {
				$fetch(`/api/save-company`, {
					method: "POST",
					body: {
						companySlug: String(props.company.slug),
						xsrf: useAuth.getXsrfToken(),
						token: useCookie("token").value,
						operation: isSavedCompany() == true ? "remove-saved-company-from-user" : "save-company-to-user", // Save or Unsave
					},
				})
					.then(() => {
						// GTM tracking
						gtm?.trackEvent({
							event: isSavedCompany() == true ? "b2c-company-unfollow" : "b2c-company-follow",
						});

						updatingCompany.value = true;
						useAuth.refreshLovedCompanyIds().then(() => {
							updatingCompany.value = false;
						});
					})
					.catch((error) => {
						console.error("Company toggleSavedCompany", error);
					});
			} else {
				router.push(`/${locale.value}/login`);
			}
		}

		function isSavedCompany() {
			return useAuth.isLovedCompany(props.company.id);
		}

		return {
			langs,
			locale,
			isAuth,
			navigateToCompanyProfile,
			isSavedCompany,
			updatingCompany,
			toggleSavedCompany,
		};
	},
});
</script>
